import { UserModel } from './../../models/user/user.model';
import { Component, ViewEncapsulation } from "@angular/core";
import { MenuItem } from './../../models/shared/menu-item.model';
import { AuthGuardService } from '../../services/auth-guard.service';
import { Configurations } from "../../core/configurations";
import { AuthService } from "../../services/auth.service";
import { UserService } from "../../services/user.service";
import { Observable } from "rxjs/Observable";
import { MdSnackBar, MdDialog, MdDialogRef } from "@angular/material";
import { ScegliZonaUVDialog } from './ScegliZonaUV.component';
import { Router } from '@angular/router';


@Component({
  selector: "left-menu",
  moduleId: module.id,
  templateUrl: "left-menu.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../../../assets/css/AngularAgentiWebCommon.css'],
})
/*
     { name: "Home",route: "LatestNews.asp?LIV=77",guidRequired: true,permissionName:"",icon:"",items: null },
     { name: "Rubrica telefonica",route: "rubrica/form.asp?LIV=75",guidRequired: true,permissionName:"",icon:"",items: null },
     { name: "Inserimento documenti",route: "bacheca/insDoc.asp?LIV=76",guidRequired: true,permissionName:"",icon:"",items: null },
     { name: "ErmesPortal",route: "http://ermesportal.q8.it",guidRequired: true,permissionName:"",icon:"",items: null },
     { name: "Extranet",route: "http://web/rolweb",guidRequired: true,permissionName:"",icon:"",items: null },

     { name: "Inserisci News",route: "insert_news.asp?LIV=114",guidRequired: true,permissionName:"",icon:"",items: null },
     { name: "Bacheca",route: "bacheca.asp?LIV=115",guidRequired: true,permissionName:"",icon:"",items: null },

     { name: "Voce di menu per gli ORDINI DI SERVIZIO",route: 
     "Bacheca.asp?Tipologia=1&Op=ShowPanel&LIV=109",guidRequired: true,permissionName:"",icon:"",items: null },
     { name: "Voce di menu per le COMUNICAZIONI",route: 
     "Bacheca.asp?Tipologia=2&Op=ShowPanel&LIV=111",guidRequired: true,permissionName:"",icon:"",items: null },
     { name: "Voce di menu per le PROCEDURE",route: 
     "Bacheca.asp?Tipologia=3&Op=ShowPanel&LIV=112",guidRequired: true,permissionName:"",icon:"",items: null },
      { name: "Download Richieste Acquisto",route: 
      "DownloadRichiesteAcquisto.asp?offset=1&LIV=125",guidRequired: true,permissionName:"",icon:"",items: null },
     { name: "Upload Documenti",route: "UploadDocumenti.asp?LIV=126",guidRequired: true,permissionName:"",icon:"",items: null },
     { name: "Download Richieste Acquisto",route: 
     "DownloadRichiesteAcquisto.asp?offset=1&LIV=128",guidRequired: true,permissionName:"",icon:"",items: null }
*/
export class LeftMenuComponent {

  currentLocation = this.router;
  menuItems: MenuItem[] = [
    { name: 'Home', route: '/', guidRequired: true, permissionName: '', icon: 'home', items: null },
    { name: 'Gestione homepage', route: '/gestione-homepage', 
      permissionName: 'Administrator,AdministratorAgentiweb', icon: '', items: null },
    { name: 'Ricerca Clienti', route: '/clienti', permissionName: 'Clienti.View', icon: '', items: null },
    { name: 'Gestione Brogliacci', route: '/brogliacci', permissionName: 'Brogliacci.View', icon: '', items: null },
    //  { name: 'Gestione Distinte Incassi',route: '/distinteincassi',permissionName: 'DistInc.View',icon: '',items: null },
    { name: 'Gestione Distinte Versamenti', route: '/distinteversamenti', permissionName: 'DistVers.View', icon: '', items: null },
    { name: 'Gestione Utenti', route: '/utenti', permissionName: 'UserPermissions.Edit', icon: '', items: null },

    //   /* link esterni Rolweb */
    {
      name: "Nuova Proposta Ordine", route: "",
      routeROL: Configurations.rolWebBaseUrl + "SceltaCliente.asp", guidRequired: true,
      permissionName: "Agente,Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Supervisore", icon: "",
      items: null, parameters: { Vis: "NO", LIV: 21 }
    },
    {
      name: "Nuova Proposta Ordine", route: "",
      routeROL: Configurations.rolWebBaseUrl + 
        "SceltaCliente.asp", guidRequired: true, permissionName: "GrandeCliente,Rivenditore", icon: "",
      items: null, parameters: { Vis: "NO", LIV: 21 }, bypassZonaUV: true
    },
    {
      name:"Portale Gadget",permissionName:"Agente,Supervisore",icon:"shopping-cart", items:null,
      route:'/services/api/dececcoredirect', bypassZonaUV: true,
      guidRequired:false, needZonaUV:false,target:"_blank",simpleLink:true

    },
    // { name: "ErmesPortal",directLink: "http://ermesportal.q8.it",permissionName:"GrandeCliente,Rivenditore",icon:"",items: null, 
    //     bypassZonaUV:true, parameters:{LIV:69},target:"_blank",guidRequired:false, needZonaUV:false },
    // { name: "Extranet",directLink: "http://web/rolweb",permissionName:"GrandeCliente,Rivenditore",icon:"",items: null, 
    //     bypassZonaUV:true, parameters:{LIV:72},target:"_blank",guidRequired:false, needZonaUV:false},
    // { name: "Rubrica telefonica",routeROL: "rubrica/form.asp",guidRequired: true,permissionName:"GrandeCliente,Rivenditore",icon:"",items: null,
    //     parameters:{LIV:75},bypassZonaUV:true },
    // { name: "Inserimento documenti",routeROL: "bacheca/insDoc.asp",guidRequired: true,permissionName:"GrandeCliente,Rivenditore",icon:"",items: null,
    //     parameters:{LIV:76},bypassZonaUV:true },        
    
    // { name: "Ordini di servizio",routeROL: "Bacheca.asp",guidRequired: true,
    //     permissionName:"Rivenditore,GrandeCliente",icon:"",items: null, parameters:{LIV:109,Tipologia:'1',Op:'ShowPanel'},bypassZonaUV:true },
    
    // { name: "Comunicazioni",routeROL: "Bacheca.asp",guidRequired: true,permissionName:"Rivenditore,GrandeCliente",icon:"",items: null 
    //     , parameters:{LIV:111,Tipologia:'2',Op:'ShowPanel'},bypassZonaUV:true },

    // { name: "Procedure",routeROL: "Bacheca.asp",guidRequired: true,permissionName:"Rivenditore,GrandeCliente",icon:"",items: null
    //     , parameters:{LIV:112,Tipologia:'3',Op:'ShowPanel'},bypassZonaUV:true  },
    // { name: "Storico news",routeROL: "Bacheca.asp",guidRequired: true,permissionName:"GrandeCliente,Rivenditore",icon:"",items: null
    //     , bypassZonaUV:true ,parameters:{LIV:115} },
    {
      name: "Informazioni", route: "", /*route: "menu.asp?LIV=22"*/ guidRequired: true,
      permissionName: "Agente,Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Rivenditore,GrandeCliente", icon: "", items:
        [
          {
            name: "Area Commerciale",
            permissionName:
              "Agente,Amministratore,Ispettore,Supervisore,Procuratore,Administrator,AdministratorAgentiweb,Rivenditore,GrandeCliente",
            guidRequired: true, icon: "", items:
              [
                {
                  name: "Consultazione Ordini", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "consultazione_ordini.asp",
                  guidRequired: true,
                  permissionName: "Agente,Ispettore,Administrator,AdministratorAgentiweb,Procuratore,Supervisore",
                  icon: "", items: null,
                  parameters: { LIV: 31 }
                },
                {
                  name: "Consultazione Ordini", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "consultazione_ordini.asp",
                  guidRequired: true, permissionName: "GrandeCliente,Rivenditore", icon: "", items: null,
                  parameters: { LIV: 31 }, bypassZonaUV: true
                },
                {
                  name: "Scheda Commerciale", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "SceltaCliente.asp",
                  guidRequired: true,
                  permissionName: "Agente,Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Supervisore",
                  icon: "", items: null,
                  parameters: { LIV: 32, Vis: "SC" }
                },
                {
                  name: "Scheda Commerciale", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "SceltaCliente.asp",
                  guidRequired: true, permissionName: "GrandeCliente,Rivenditore", icon: "", items: null,
                  parameters: { LIV: 32, Vis: "SC" }, bypassZonaUV: true
                },
                {
                  name: "Elenco Clienti", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "SceltaCliente.asp",
                  guidRequired: true,
                  permissionName: "Agente,Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Supervisore",
                  icon: "", items: null,
                  parameters: { LIV: 33, Vis: "E" }
                },
                {
                  name: "Elenco Prodotti", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "altro_prodotto.asp",
                  guidRequired: true,
                  permissionName: "Agente,Administrator,AdministratorAgentiweb,Ispettore,Procuratore,Supervisore", icon: "", items: null,
                  parameters: { LIV: 34, Oper: "ELE" }
                },
                // { name: "Elenco Prodotti",route:"", 
                // routeROL:Configurations.rolWebBaseUrl+ "altro_prodotto.asp",
                // guidRequired: true,permissionName:"GrandeCliente,Rivenditore",icon:"",items: null,
                // parameters:{LIV:34, Oper:"ELE"},bypassZonaUV:true  },
                {
                  name: "Elenco Prodotti",
                  routeROL: Configurations.rolWebBaseUrl + "SceltaCliente.asp",
                  guidRequired: true, permissionName: "AdministratorAgentiweb", icon: "", items: null,
                  parameters: { LIV: 42, Vis: "PR" }
                },

                {
                  name: "Elenco Prodotti",
                  routeROL: Configurations.rolWebBaseUrl + "SceltaCliente.asp",
                  guidRequired: true, permissionName: "GrandeCliente,Rivenditore", icon: "", items: null,
                  parameters: { LIV: 42, Vis: "PR" }, bypassZonaUV: true
                },
                {
                  name: "Catalogo Prodotti", route: "",
                  routeROL: Configurations.published ? "https://www.q8oilsitalia.it/RolWebNet/Catalogo/Home.aspx" :
                    Configurations.rolWebBaseUrl + "../RolWebNet/Catalogo/Home.aspx",
                  guidRequired: true,
                  permissionName: "Agente,Administrator,AdministratorAgentiweb,Ispettore,Procuratore,Supervisore",
                  icon: "", items: null,
                  parameters: { LIV: 130 }
                },
                {
                  name: "FocalPoint NONoil", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "ConfermaVenditaManuale_focal.asp",
                  guidRequired: true,
                  permissionName: "Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Supervisore",
                  icon: "", items: null,
                  parameters: { LIV: 136 }
                }
              ]
          },
          {
            name: "Area Contabile", route: "", guidRequired: true,
            permissionName: "Agente,Ispettore,Procuratore,Supervisore,Administrator,AdministratorAgentiweb,Rivenditore,GrandeCliente",
            icon: "", items:
              [
                {
                  name: "Estratto Conto", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "SceltaCliente.asp", guidRequired: true,
                  permissionName: "Agente,Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Supervisore",
                  icon: "", items: null,
                  parameters: { LIV: 29, Vis: "EC" }
                },
                {
                  name: "Estratto Conto", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "SceltaCliente.asp", guidRequired: true,
                  permissionName: "Rivenditore,GrandeCliente", bypassZonaUV:true,
                  icon: "", items: null,
                  parameters: { LIV: 29, Vis: "EC" }
                },
                {
                  name: "Elenco Degli Scoperti", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "EC_ScopertiElenco.asp",
                  guidRequired: true,
                  permissionName: "Agente,Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Supervisore",
                  icon: "", items: null,
                  parameters: { LIV: 30 }
                },
                {
                  name: "Elenco Degli Scoperti", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "EC_ScopertiElenco.asp",
                  guidRequired: true, bypassZonaUV:true,
                  permissionName: "Rivenditore,GrandeCliente",
                  icon: "", items: null,
                  parameters: { LIV: 30 }
                },
                {
                  name: "Totale Scoperti", route: "",
                  routeROL: Configurations.rolWebBaseUrl + "TotaleScoperti.asp",
                  guidRequired: true,
                  permissionName: "Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Supervisore",
                  icon: "", items: null,
                  parameters: { LIV: 41 }
                }
              ]
          },
          {
            name: "Area Logistica Magazzini", route: "",
            routeROL: Configurations.rolWebBaseUrl + "arealogistica.asp",
            guidRequired: true,
            permissionName: "Agente,Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Supervisore",
            icon: "", items: null,
            parameters: { LIV: 58 }
          },
          {
            name: "Schede Tecniche", route: "",
            routeROL: Configurations.published ? "https://www.q8oilsitalia.it/RolWebNet/SchedeTecniche.aspx" :
              Configurations.rolWebBaseUrl + "../RolWebNet/SchedeTecniche.aspx",
            guidRequired: true,
            permissionName: "Agente,Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Supervisore",
            icon: "", items: null,
            parameters: { LIV: 121 }
          },
          {
            name: "Archivio Comunicati", route: "",
            routeROL: Configurations.published ? "https://www.q8oilsitalia.it/RolWebNet/ArchivioComunicati.aspx" :
              Configurations.rolWebBaseUrl + "../RolWebNet/ArchivioComunicati.aspx",
            guidRequired: true,
            permissionName: "Agente,Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Supervisore",
            icon: "", items: null,
            parameters: { LIV: 123 }
          },
          {
            name: "Messaggi", route: "",
            routeROL: Configurations.published ? "https://www.q8oilsitalia.it/RolWebNet/Messaggi.aspx" :
              Configurations.rolWebBaseUrl + "../RolWebNet/Messaggi.aspx",
            guidRequired: true,
            permissionName: "Agente,Administrator,AdministratorAgentiweb,Ispettore,Procuratore,Supervisore",
            icon: "", items: null,
            parameters: { LIV: 122 }
          }
        ]
    },
    {
      name: "Validazione Ordini", route: "",
      routeROL: Configurations.rolWebBaseUrl + "Val_Elenco.asp",
      guidRequired: true,
      permissionName: "Administrator,AdministratorAgentiweb,Ispettore,Procuratore,Supervisore", icon: "", items: null,
      parameters: { LIV: 37 }
    },
    {
      name: "Contenzioso", route: "",
      routeROL: Configurations.published ? "https://www.q8oilsitalia.it/RolWebNet/Contenzioso.aspx" :
        Configurations.rolWebBaseUrl + "../RolWebNet/Contenzioso.aspx",
      guidRequired: true, permissionName: "Undefined", icon: "", items: null,
      parameters: { LIV: 139 }
    },
    {
      name: "Statistiche", route: "", guidRequired: true,
      permissionName: "Agente,Ispettore,Procuratore,Supervisore,Administrator,AdministratorAgentiweb",
      icon: "", items:
        [
          {
            name: "Statistica 79 Ele", route: "",
            routeROL: Configurations.rolWebBaseUrl + "Stat_79Det.asp",
            guidRequired: true,
            permissionName: "Agente,Ispettore,Procuratore,Supervisore,Administrator,AdministratorAgentiweb",
            icon: "", items: null,
            parameters: { LIV: 35 }
          },
          {
            name: "Statistica 79 Tot", route: "",
            routeROL: Configurations.rolWebBaseUrl + "Stat_79Tot.asp",
            guidRequired: true,
            permissionName: "Agente,Ispettore,Procuratore,Supervisore,Administrator,AdministratorAgentiweb",
            icon: "", items: null,
            parameters: { LIV: 36 }
          },
          {
            name: "Statistica 11 Ele", route: "",
            routeROL: Configurations.rolWebBaseUrl + "Stat_11Det.asp", guidRequired: true,
            permissionName: "Agente,Ispettore,Procuratore,Administrator,AdministratorAgentiweb,Supervisore",
            icon: "", items: null,
            parameters: { LIV: 134 }
          },
          {
            name: "Statistica 11 Tot", route: "",
            routeROL: Configurations.rolWebBaseUrl + "Stat_11Tot.asp",
            guidRequired: true,
            permissionName: "Agente,Ispettore,Procuratore,Supervisore,Administrator,AdministratorAgentiweb",
            icon: "", items: null,
            parameters: { LIV: 135 }
          },
          {
            name: "Quaderno di Produzione OIL", route: "",
            routeROL: Configurations.rolWebBaseUrl + "QuadernoProduzione.asp",
            guidRequired: true,
            permissionName: "Agente,Ispettore,Procuratore,Supervisore,Administrator,AdministratorAgentiweb",
            icon: "", items: null,
            parameters: { LIV: 137, Tipo: "O" }
          },
          {
            name: "Quaderno di Produzione NONOIL", route: "",
            routeROL: Configurations.rolWebBaseUrl + "QuadernoProduzione.asp",
            guidRequired: true,
            permissionName: "Agente,Ispettore,Procuratore,Supervisore,Administrator,AdministratorAgentiweb",
            icon: "", items: null,
            parameters: { LIV: 138, Tipo: "N" }
          }
        ]
    },
    {
      name: "Gestione Utenti", route: "",
      routeROL: Configurations.rolWebBaseUrl + "UT_UtentiElenco.asp",
      guidRequired: true,
      permissionName: "AdministratorAgentiweb",
      icon: "", items: null,
      parameters: { LIV: 38 }
    },
    {
      name: "Connessioni", route: "",
      routeROL: Configurations.rolWebBaseUrl + "connessioni.asp",
      guidRequired: true, permissionName: "AdministratorAgentiweb",
      icon: "", items: null,
      parameters: { LIV: 39 }
    },
    //  { name: "Cambia Uv Zona",route:"", routeROL:Configurations.rolWebBaseUrl+ "start.asp?LIV=40",
    //guidRequired: true,permissionName:"Agente,Ispettore,Procuratore,Supervisore,Administrator,AdministratorAgentiweb",
    //icon:"",items: null },
    {
      name: "Cambia Uv Zona (per ROLWEB)", route: "", guidRequired: true,
      permissionName: "Agente,Ispettore,Procuratore,Supervisore,Administrator,AdministratorAgentiweb",
      icon: "", items: null, isChangeUVCommand: true, alwaysVisible: true
    },
    {
      name: "Liste Giro", route: "", guidRequired: true, permissionName: "Trasportatore", icon: "", items:
        [
          {
            name: "Elenco completo liste giro", route: "",
            routeROL: Configurations.rolWebBaseUrl + "Trasp_ListaGiro.asp", guidRequired: true,
            permissionName: "Trasportatore", icon: "", items: null,
            parameters: { LIV: 104, offset: "1" }, bypassZonaUV: true
          },
        ]
    },
    //  { name: "Controllo Fatturazione",route:"", 
    //  routeROL:Configurations.rolWebBaseUrl+ "Trasp_ContrFatt_Testata.asp",
    //  guidRequired: true,permissionName:"GrandeCliente",icon:"",items: null,
    //  parameters:{LIV:101}, bypassZonaUV:true  },
    {
      name: "Gestione Acquisti/Consegne", route: "", /*route: "menu.asp?LIV=127",*/
      guidRequired: true, permissionName: "FornitoreDeposito,Fornitore", icon: "", items:
        [
          {
            name: "Download Richieste Acquisto", route: "",
            routeROL: Configurations.rolWebBaseUrl + "DownloadRichiesteAcquisto.asp",
            parameters: { offset: "1", LIV: 128 }, bypassZonaUV: true,
            guidRequired: true, permissionName: "FornitoreDeposito,Fornitore", icon: "", items: null
          },
          {
            name: "Upload Documenti", route: "",
            routeROL: Configurations.rolWebBaseUrl + "UploadDocumenti.asp",
            guidRequired: true, permissionName: "FornitoreDeposito,Fornitore", icon: "", items: null,
            parameters: { LIV: 129 }, bypassZonaUV: true
          },
          {
            name: "Conferma Vendita Manuale",
            route: "", routeROL: Configurations.rolWebBaseUrl + "ConfermaVenditaManuale.asp",
            guidRequired: true, permissionName: "FornitoreDeposito,Fornitore", icon: "", items: null,
            parameters: { LIV: 133 }, bypassZonaUV: true
          }
        ]
    },
    {
      name: "Upload Documenti Trasportatori", route: "",
      routeROL: Configurations.rolWebBaseUrl + "Trasp_UploadDocumenti.asp",
      guidRequired: true, permissionName: "Trasportatore", icon: "", items: null,
      parameters: { LIV: 131 }, bypassZonaUV: true
    },
    {
      name: "Statistiche di vendita BC", route: "", routeROL: "BC_statven.asp",
      guidRequired: true, permissionName: "GrandeCliente", icon: "", items: null,
      parameters: { LIV: 120 }, bypassZonaUV: true
    },
    {
      name: "Gestione Depositi", route: "", guidRequired: true, permissionName: "Depositario,FornitoreDeposito", icon: "", items:
        [
          // {
          //   name: "Gestione depositi", route: "",
          //   routeROL: Configurations.rolWebBaseUrl + "menu.asp",
          //   guidRequired: true, permissionName: "Depositario,FornitoreDeposito",
          //   icon: "", items: null,
          //   //parameters: { LIV: 83 }, 
          //   bypassZonaUV: true
          // },
          // {
          //   name: "Download dati depositi", route: "",
          //   routeROL: Configurations.rolWebBaseUrl + "ScaricoDati.asp",
          //   guidRequired: true, permissionName: "Depositario,FornitoreDeposito",
          //   icon: "", items: null,
          //   parameters: { LIV: 83 }, bypassZonaUV: true
          // },
          {
            name: "Stampa bolle e/o distinte", route: "",
            routeROL: Configurations.rolWebBaseUrl + "StampaDocTrasp.asp",
            guidRequired: true, permissionName: "Depositario,FornitoreDeposito,Fornitore",
            icon: "", items: null,
            parameters: { LIV: 79 }, bypassZonaUV: true
          },
          {
            name: "Stampa distinte", route: "",
            routeROL: Configurations.rolWebBaseUrl + "StampaDistinte.asp",
            guidRequired: true, permissionName: "Depositario,FornitoreDeposito,Fornitore",
            icon: "", items: null,
            parameters: { LIV: 80 }, bypassZonaUV: true
          },
          {
            name: "Stampa rimanenze", route: "",
            routeROL: Configurations.rolWebBaseUrl + "StampaRimanenze.asp",
            guidRequired: true, permissionName: "Depositario,FornitoreDeposito,Fornitore",
            icon: "", items: null,
            parameters: { LIV: 81 }, bypassZonaUV: true
          },
          {
            name: "Stampa segnacolli", route: "",
            routeROL: Configurations.rolWebBaseUrl + "StampaSegnacolli.asp",
            guidRequired: true, permissionName: "Depositario,FornitoreDeposito,Fornitore",
            icon: "", items: null,
            parameters: { LIV: 82 }, bypassZonaUV: true
          }
          // ,
          //  { name: "Installazione SW per stampa client",route:"",
          //   routeROL:Configurations.rolWebBaseUrl+"InstallazioneSWDepositi.asp",
          //   guidRequired: true,permissionName:"Depositario,FornitoreDeposito,Fornitore",
          //   icon:"",items: null,
          //  parameters:{LIV:87}, bypassZonaUV:true  }
        ]
    },
    // {
    //   name: "Menu Web Agente", 
    //   route: "", 
    //   permissionName: "Depositario,FornitoreDeposito",
    //   simpleLink:true,
    //   routeROL:"", 
    //   target:"_blank"
    //   // routeROL: Configurations.rolWebBaseUrl + "ScaricoDati.asp",
    //   // guidRequired: true,
    //   // icon: "", items: null,
    //   // parameters: { LIV: 83 }, bypassZonaUV: true
    // },
    {
      name: "Ordini Automatici", route: "", guidRequired: true, permissionName: "GrandeCliente", icon: "", items:
        [
          {
            name: "Upload ordini", route: "",
            routeROL: Configurations.rolWebBaseUrl + "BC_upload.asp",
            guidRequired: true, permissionName: "GrandeCliente",
            icon: "", items: null,
            parameters: { LIV: 118 }, bypassZonaUV: true
          },
          {
            name: "Download ordini", route: "",
            routeROL: Configurations.rolWebBaseUrl + "BC_download.asp",
            guidRequired: true, permissionName: "GrandeCliente", icon: "", items: null,
            parameters: { LIV: 119 }, bypassZonaUV: true
          }
        ]
    },
    //  { name: "Gestione incassi",route:"",
    //   routeROL:"GestioneIncassi_Movimenti.asp",
    //   guidRequired: true,
    //   permissionName:"Agente,Ispettore,Supervisore,Procuratore,Administrator,AdministratorAgentiweb",
    //   icon:"",items: null,
    //  parameters:{LIV:84}  },
    {
      name: "Contattaci", route: "",
      routeROL: Configurations.rolWebBaseUrl + "InvioMail.asp", guidRequired: true,
      permissionName: "Agente,Ispettore,Supervisore,Procuratore,Administrator,AdministratorAgentiweb",
      icon: "", items: null,
      parameters: { LIV: 24 }
    },
    {
      name: "Contattaci", route: "",
      routeROL: Configurations.rolWebBaseUrl + "InvioMail.asp",
      guidRequired: true, permissionName: "GrandeCliente,Rivenditore,Depositario,Trasportatore,FornitoreDeposito,Fornitore",
      icon: "", items: null,
      parameters: { LIV: 24 }, bypassZonaUV: true
    }


  ];


  private _user: UserModel;
  private _choosingZonaUV: boolean;
  constructor(
    public authGuardService: AuthGuardService,
    private authService: AuthService,
    private userService: UserService,
    private snackBar: MdSnackBar,
    private cambiaZonaUVDialog: MdDialog,
    private conf: Configurations,
    private router: Router
  ) {

    this._user = authService.user;
  }


  showMenuItem(menuItem): boolean {

    if (menuItem.permissionName !== "") {
      let value = this.authGuardService.checkPermission(menuItem.permissionName);
      return value;
    }

    return true;
  }

  staticLinkClick(menuItem: MenuItem) {
    this.authService.logoutIfSessionExpired().subscribe();
    let scegliZonaUV: MdDialogRef<ScegliZonaUVDialog> = null;
    if (!menuItem.isChangeUVCommand) {
      if(menuItem.directLink!=null){
        window.open(menuItem.directLink,menuItem.target||'_blank');
      }
      if ((!this._user.chosenUV || !this._user.chosenZona) && !menuItem.bypassZonaUV) {
        this.showError
          ("Per poter utilizzare questa funzionalità, è necessario scegliere l'unità di vendita/zona interessata attraverso la voce di menù 'Cambia Uv Zona (per ROLWEB)'");
        return;
      }
      let urlTo = Configurations.rolWebBaseUrl + "RolWebLink.html";
      var win = window.open(urlTo, '_blank');
    } else {
      scegliZonaUV = this.cambiaZonaUVDialog.open(
        ScegliZonaUVDialog, { data: { utenteRef: this.authService.user } }

      );
      scegliZonaUV.disableClose = true;
      let shallReOpen = false;
      scegliZonaUV.beforeClose().subscribe(
        data => {
          if (!scegliZonaUV.componentInstance.toClose) {
            shallReOpen = true;

          } else {
            shallReOpen = false;
          }
        }
      );
      scegliZonaUV.afterClosed().subscribe(
        data => {
          if (shallReOpen) {
            scegliZonaUV = this.cambiaZonaUVDialog.open(
              ScegliZonaUVDialog, { data: { utenteRef: this.authService.user } }

            );
          }
        }
      );
    }
    this.userService.RefreshSIUTokenRequest(this._user.token).subscribe(
      data => {
        if (data.isSIUTokenRenewed === true) {
          if (!menuItem.isChangeUVCommand) {

            let scope = this;
            let url = menuItem.routeROL + '?GUID=' + data.siuToken;
            let urlTo = Configurations.rolWebBaseUrl + "RolWebLink.html?GUID=" + data.siuToken;
            for (let par in menuItem.parameters) {
              url = url + "&" + par + "=" + menuItem.parameters[par];
            }
            urlTo += "&url=" + encodeURIComponent(url);
            win.location.href = urlTo;
          } else {
            scegliZonaUV.componentInstance.start();
          }
        } else {
          if (scegliZonaUV != null) {
            scegliZonaUV.close();
          }
          this.showError(data.message);
        }
      });
  }
  cambiaUVZONA() {
    this._choosingZonaUV = true;

    let scegliZonaUV = this.cambiaZonaUVDialog.open(
      ScegliZonaUVDialog, { data: { utenteRef: this.authService.user } }

    )
      // .afterClosed().subscribe(
      //   ()=>{
      //     if(menuItem!=null){

      //       let scope=this;
      //       let url = menuItem.routeROL + '?GUID='+ siuToken;
      //       for(let par in menuItem.parameters)
      //       {
      //         url=url+"&"+par+"="+menuItem.parameters[par];
      //       }
      //       win.location.href=url;
      //     }
      //   }
      // )
      ;

  }
  nascondiCambiaZona() {
    this._choosingZonaUV = false;
  }
  sendUVZONA() {
    //TODO:Logica sending zona
    this.nascondiCambiaZona();
  }
  /*
  staticLinkClick_(menuItem: MenuItem) {

    console.log('staticLinkClick: ',menuItem.route);
    if(menuItem.guidRequired==true) {

      // let win=window.open("","_blank");
      // win.location.href="https://" + this.conf.rolWebAuthUser + ":" + this.conf.rolWebAuthPW + "@" + this.conf.rolWebUrl;
    //chiamata al servizio
    this.userService.RefreshSIUTokenRequest(this._user.token).subscribe(
      data=>{
       if(data.isSIUTokenRenewed==true){
        let scope=this;
          //chiamata ajax
          $.ajax({
            url: "https://" + this.conf.rolWebUrl,
            xhrFields: { withCredentials: true },
            async: false,
            type: 'GET',
            //dataType:'jsonp',
            //crossDomain: true,
            beforeSend: function (xhr) {
              xhr.setRequestHeader ("Authorization","Basic " + scope.conf.rolWebAuthToken);
              xhr.withCredentials=true;
            },
            success: function (res) {
               //apertura link
                let url = menuItem.route + '&GUID='+ data.siuToken;
                //let url="https://" + this.configuration.rolWebAuthUser + ":" + this.configuration.rolWebAuthPW + "@" + this.configuration.rolWebUrl+ '&GUID='+ data.siuToken;
                var win=window.open("",'_blank');
                
                //win.document.cookie=document.cookie;
                win.location.href=url;
                
            },
            error: function (res,textStatus,errorThrown) {
              console.log(res);
              if(res.status==401){
                scope.showError("Sessione terminata,rieffettuare il login e riprovare.");
                scope.authService.logout(true);
              }
              if(res.status==200){
                let url = menuItem.route + '&GUID='+ data.siuToken;
                //let url="https://" + this.configuration.rolWebAuthUser + ":" + this.configuration.rolWebAuthPW + "@" + this.configuration.rolWebUrl+ '&GUID='+ data.siuToken;
                var win=window.open("",'_blank');
                win.location.href=url;
              }
              else{
                scope.showError("Errore durante l'accesso al vecchio sistema.");
              }
            }
          });
         
      }else{
          this.showError(data.message);
      } 
    }

    );
    
  }
  return false;
  }*/
  private showError(message: string) {
    this.snackBar.open("Errore: " + message, 'Chiudi', { duration: 5000 });
    console.log(message);
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/layout/left-menu.component.ts